export default {
    pageTitle: 'Settings',
    leftPanel: {
        teamDetails: 'Organization',
        users: 'Users',
        templates: 'Templates',
        profile: 'Profile',
        notifications: 'Notifications',
        messages: 'Automated messages',
        usage: {
            title: 'Usage',
            segmentsSent: '{usage} / {limit} SMS used this month',
        },
    },
    rightPanel: {
        profile: {
            firstName: 'First Name',
            lastName: 'Last Name',
            locale: 'Language',
            timezone: 'Timezone',
            email: 'Email',
            password: 'Password',
            confirm: 'Confirm password',
            subtitles: {
                profile: 'Profile',
                general: 'General',
                localization: 'Localization',
                changePassword: 'Change password',
                createPassword: 'Create password',
            },
            messages: {
                updateSuccessful: 'Updated profile successfully.',
            },
            errors: {
                update: 'An error occured while saving. Please try again.',
            },
        },
        notifications: {
            type: 'Notification type',
            screen: 'Screen',
            email: 'Email',
            newMessageConfirmation: 'New message',
            subtitles: {
                notifications: 'Notifications',
            },
            messages: {
                updateSuccessful: 'Updated notifications settings successfully.',
            },
            errors: {
                update: 'An error occured while saving. Please try again.',
            },
        },
        messages: {
            unsubscribeMessage: 'Unsubscribe Message',
            unsubscribeMessageTooltip: 'This message is sent automatically after a first mass communication is sent to the client like an appointment confirmation or a campaign. It is necessary to comply with Canada\'s Anti-Spam Legislation.',
            confirmationMessage: 'Confirmation Message',
            confirmationMessageTooltip: 'This message is appended automatically to appointment confirmation messages. It should indicate the client what to reply to confirm or cancel his appointment.',
            paymentMessage: 'Payment Link Message',
            paymentMessageTooltip: 'This message is appended automatically when you send a payment link. It is followed by the link.',
            crmAppointmentConfirmation: 'CRM Appointment Confirmation',
            crmAppointmentConfirmationTooltip: 'This message is sent for appointment confirmation planned from a client card in the CRM.',
            appendConfirmationMessage: 'Append confirmation message to this message',
            insertAttribute: 'Insert attribute',
            unsubscribeMessageWarning: 'We recommend to write a message because the law requires you to provide an unsubscribe mecanism for marketing communications.',
            crmConfirmationWarning: 'If the CRM appointment confirmation message is defined in only one language, it will be used for every languages.',
            crmConfirmationError: 'The CRM appointment confirmation message is required in at least one language.',
            subtitles: {
                messages: 'Automated messages',
            },
            messages: {
                updateSuccessful: 'Updated automated messages successfully.',
            },
            errors: {
                update: 'An error occured while saving. Please try again.',
            },
        },
        teamDetails: {
            address: 'Address',
            city: 'City',
            province: 'Province',
            state: 'State',
            country: 'Country',
            postalCode: 'Postal code',
            zip: 'ZIP Code',
            hasAppointments: 'Access to appointments',
            doesNotHaveAppointments: 'No access to appointments',
            hasCampaigns: 'Access to campaigns',
            doesNotHaveCampaigns: 'No access to campaigns',
            hasPayments: 'Access to payments',
            doesNotHavePayments: 'No access to payments',
            phone: 'Phone',
            name: 'Name',
            timezone: 'Timezone',
            appointmentAccess: 'Appointments',
            campaignAccess: 'Campaigns',
            paymentAccess: 'Payments',
            number: 'Number',
            noPhones: 'No phone numbers.',
            subtitles: {
                teamDetails: 'Organization details',
                phones: 'Phone numbers',
                modules: 'Modules',
            },
            messages: {
                updateSuccessful: 'Updated organization details successfully.',
            },
            errors: {
                fetchingPhones: 'Unable to fetch the organization\'s phones.',
                fetchingAccount: 'Unable to fetch the account.',
                update: 'An error occured while saving. Please try again.',
            },
        },
        users: {
            leftNav: {
                profile: 'Profile',
                notifications: 'Notifications',
                messages: 'Automated messages',
                permissions: 'Permissions',
            },
            name: 'Name',
            email: 'Email',
            active: 'Active',
            noUsers: 'No users yet.',
            userModal: {
                addTitle: 'New User',
                editTitle: 'Edit User',
                password: 'Password',
                passwordConfirmation: 'Password Confirmation',
                locale: 'Locale',
                isActive: 'User is enabled',
                isNotActive: 'User is disabled',
                successMessage: 'User created successfully.',
                updateMessage: 'User updated successfully.',
                deleteMessage: 'User deleted successfully.',
            },
            deleteModal: {
                header: 'Delete user',
                message: 'Are you sure you want to delete this user?',
            },
            subtitles: {
                users: 'Users',
            },
            errors: {
                fetchingUsers: 'Unable to fetch users.',
            },
            permissions: {
                type: 'Administrable Permissions',
                appointmentModule: 'Appointments Module',
                campaignModule: 'Campaigns Module',
                paymentModule: 'Payments Module',
                teamSettings: 'Organization Settings',
                otherUsersConversations: 'Other users conversations (Read-only)',
                subtitles: {
                    permissions: 'Permissions',
                },
                allowed: 'Allowed',
            },
        },
        templates: {
            title: 'Message Templates',
            categories: 'Categories',
            templates: 'Templates',
        },
    },
};
